var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gravity-ui:clock-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15.5C9.85652 15.5 11.637 14.7625 12.9497 13.4497C14.2625 12.137 15 10.3565 15 8.5C15 6.64348 14.2625 4.86301 12.9497 3.55025C11.637 2.2375 9.85652 1.5 8 1.5C6.14348 1.5 4.36301 2.2375 3.05025 3.55025C1.7375 4.86301 1 6.64348 1 8.5C1 10.3565 1.7375 12.137 3.05025 13.4497C4.36301 14.7625 6.14348 15.5 8 15.5ZM8.75 5C8.75 4.80109 8.67098 4.61032 8.53033 4.46967C8.38968 4.32902 8.19891 4.25 8 4.25C7.80109 4.25 7.61032 4.32902 7.46967 4.46967C7.32902 4.61032 7.25 4.80109 7.25 5V8.5C7.25 8.61643 7.27711 8.73127 7.32918 8.83541C7.38125 8.93955 7.45685 9.03014 7.55 9.1L9.55 10.6C9.62879 10.6591 9.71845 10.7021 9.81386 10.7265C9.90928 10.751 10.0086 10.7564 10.1061 10.7425C10.2036 10.7285 10.2974 10.6955 10.3821 10.6454C10.4669 10.5952 10.5409 10.5288 10.6 10.45C10.6591 10.3712 10.7021 10.2815 10.7265 10.1861C10.751 10.0907 10.7564 9.99144 10.7425 9.89393C10.7285 9.79643 10.6955 9.70263 10.6454 9.61788C10.5952 9.53313 10.5288 9.45909 10.45 9.4L8.75 8.125V5Z",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1cf3b6cf419bac06081f8f7a76517d49.svg";
export { ForwardRef as ReactComponent };